export default __webpack_public_path__ + "static/media/burger-menu-svgrepo-com.7e8e5c3d.svg";